<template>
  <section>
    <div class="flex items-start justify-between gap-3 border-b border-gray-100 px-1 pb-2">
      <div class="min-w-0">
        <h2 class="truncate text-[15px] font-bold leading-tight text-gray-900 desk:text-lg">{{ catalog.name }}</h2>
        <p
          v-if="catalog.description"
          class="mt-1 line-clamp-1 text-[11px] leading-tight text-gray-500 desk:text-xs"
        >
          {{ catalog.description }}
        </p>
      </div>
      <nuxt-link
        :to="localePath({ name: 'order', query: { category: catalog.no, title: catalog.name } })"
        class="flex flex-none items-center pt-0.5 text-[11px] font-medium text-primary active:opacity-70 desk:min-h-[44px] desk:text-sm desk:hover:underline"
      >
        查看全部
        <ChevronRightIcon class="ml-0.5 h-3.5 w-3.5" />
      </nuxt-link>
    </div>

    <LoadingVue class="mx-auto text-primary h-20" v-if="fetching" />

    <div class="grid grid-cols-4 gap-x-2 gap-y-4 pt-3 desk:gap-x-5 desk:gap-y-6 desk:pt-4 wide:grid-cols-6" v-if="!fetching">
      <ListItem
        v-for="(item, index) in records"
        :key="index"
        :item="item"
        :index="index"
        :hasCaption="true"
      />
    </div>
  </section>
</template>

<script>
import ListItem from "@/components/product/ListItem.vue";
import LoadingVue from "@luminexs/components/icons/Loading.vue";
import { ChevronRightIcon } from "@vue-hero-icons/outline";
import { mapActions, mapGetters } from "vuex";
import { find } from "lodash";

export default {
  components: {
    ListItem,
    LoadingVue,
    ChevronRightIcon,
  },
  props: {
    catalog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fetching: false,
    };
  },
  methods: {
    ...mapActions({
      setRecommend: "app/setRecommend",
    }),
    fetch() {
      this.fetching = true;

      this.$axios
        .get(`/api/catalogs/${this.catalog.id}/recommend`)
        .then(({ data }) => {
          this.setRecommend({ no: this.catalog.id, items: data.data });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      recommend: "app/recommend",
    }),
    records() {
      return find(this.recommend, { no: this.catalog.id })?.items || [];
    },
  },
  created() {
    if (!this.records.length) this.fetch();
  },
};
</script>

<style lang="scss" scoped></style>
